// extracted by mini-css-extract-plugin
module.exports = {"container":"bespoke-module__container___CO8S4","banner":"bespoke-module__banner___YT1Dp"};